/* eslint-disable @typescript-eslint/no-explicit-any
 */
import React, { ReactElement, useEffect, useState } from 'react';

import { Box, Typography } from '@mui/material';
import { Button, Header } from 'components/ui';
import { Link } from 'components/lib';
import backgroundImage from 'public/img/app-screens.png';

interface InstallPrompt {
  prompt(): void;
  userChoice: Promise<{ outcome: string }>;
}

export default function AppDownloadPage(): ReactElement {
  const [installPrompt, setInstallPrompt] = useState<InstallPrompt>();
  const [unableToDownload, setUnableToDownload] = useState(false);

  useEffect(() => {
    if ('onbeforeinstallprompt' in window) {
      const handleInstallPrompt = (e: Event) => {
        e.preventDefault();
        setInstallPrompt((e as any) as InstallPrompt);
      };
      window.addEventListener('beforeinstallprompt', handleInstallPrompt);

      return () => {
        window.removeEventListener('beforeinstallprompt', handleInstallPrompt);
      };
    }

    setUnableToDownload(true);
  }, []);

  const handleDownloadClick = () => {
    if (installPrompt) {
      installPrompt.prompt();
      installPrompt.userChoice.then(() => {
        setInstallPrompt(undefined);
      });
    }
  };

  return (
    <Box>
      <Box
        bgcolor={{ xs: '#23305F', md: 'none' }}
        sx={{
          height: 60,
          p: 20,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Header loggedIn={false} showSearch={false}></Header>
      </Box>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          padding: 16,
        }}
      >
        <Typography textAlign="center" variant="h3" mt={48} mb={16}>
          Get The CampusLush App
        </Typography>
        <Box
          component="img"
          src={backgroundImage.src}
          sx={{
            width: 350,
            maxWidth: '100%',
            mb: 16,
          }}
        />
        {unableToDownload ? (
          <Typography
            textAlign="center"
            color="error"
            variant="h4"
            mt={48}
            mb={16}
          >
            We&apos;re Sorry! CampusLush app download is not supported on your
            device
          </Typography>
        ) : (
          <>
            <Typography textAlign="center" variant="h6" fontSize={16} mb={16}>
              Download CampusLush for iOS, Android, or desktop.
            </Typography>
            <Button
              variant="vibrant"
              minHeight={48}
              onClick={handleDownloadClick}
              sx={{ mb: 16 }}
            >
              Download App
            </Button>
            <Link href="/">
              <Typography
                textAlign="center"
                variant="caption"
                sx={{ textDecoration: 'underline' }}
              >
                Remind Me Later
              </Typography>
            </Link>
          </>
        )}
      </Box>
    </Box>
  );
}
